export enum PageState {
  About,
  WorkEx,
  Projects,
  Games,
  Contact,
}
